(ns iris.error.views
  (:require
   [re-frame.core :as re-frame]
   [iris.error.subs :as subs]
   [iris.common :as common]))

(defn error-panel []
  (let [error (re-frame/subscribe [::subs/error])]
    [:<>
     [:div.container
      [:div.row
       [:div.col-sm-12
        [:h1.text-center (:title @error)]
        [:p.text-center {:style {:font-size "1.6rem"
                                 :margin-top "20px"}} (:message @error)]
        (when (:a-href @error)
          [:div.text-center
           [:a {:href (:a-href @error)
                :style {:display "inline-block"
                        :font-size "1.6rem"
                        :margin-top "20px"}}
            (:a-txt @error)]])]]]
     ]))